/* eslint-disable arrow-body-style */
const departmentSelectStyles = {
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#E8F4FB",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#D2EAF8" : "transparent",
    display: "flex",
  }),
  placeholder: (provided) => ({
    ...provided,
    display: "flex",
    position: "absolute",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "3px 8px",
  }),
  control: (provided) => ({
    ...provided,
    borderColor: "#9daebb",
    cursor: "pointer",
  }),
};

export default departmentSelectStyles;
